import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { AlertsContainer, ConfirmModalContainer } from '@/components/molecule';
import { OptionsContainer } from '@/components/template';
import { alertsReducer, confirmModalReducer, presetsReducer } from '@/slices';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const root = document.getElementById('root');
if (root) {
  const store = configureStore({
    reducer: {
      confirmModal: confirmModalReducer,
      presets: presetsReducer,
      alerts: alertsReducer
    },
    devTools: false,
    middleware: getDefaultMiddleware({
      thunk: true,
      immutableCheck: false,
      serializableCheck: false
    })
  });
  ReactDOM.render( /*#__PURE__*/_jsxs(Provider, {
    store: store,
    children: [/*#__PURE__*/_jsx(ConfirmModalContainer, {}), /*#__PURE__*/_jsx(AlertsContainer, {}), /*#__PURE__*/_jsx(OptionsContainer, {})]
  }), document.getElementById('root'));
}